require('./product-brands-list.scss')

module.exports = {
  template: require('./product-brands-list.pug')()
  controller: require('./product-brands-list.ctrl')
  bindings:
    productBrands: '<'
    onProductBrandDelete: '&'
    query: '<',
    total: '<',
    onRefresh: '&'
}
